import useEmblaCarousel from "embla-carousel-react";
import { EmblaOptionsType, EmblaCarouselType } from "embla-carousel";
import { useEffect, useState } from "react";

function useCarouselState(api?: EmblaCarouselType) {
  const [current, setCurrent] = useState(0);
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    if (!api) return;

    const onSelect = () => setCurrent(api.selectedScrollSnap());
    const onResize = () => setCurrent(api.selectedScrollSnap());
    const onScroll = () => setDragging(true);
    const onSettle = () => setDragging(false);

    setCurrent(api.selectedScrollSnap());
    api.on("select", onSelect);
    api.on("resize", onResize);
    api.on("scroll", onScroll);
    api.on("settle", onSettle);

    return () => {
      api.off("select", onSelect);
      api.off("resize", onResize);
      api.off("scroll", onScroll);
      api.off("settle", onSettle);
    };
  }, [api]);

  return { current, dragging };
}

export function useCarousel(props?: EmblaOptionsType) {
  const [ref, api] = useEmblaCarousel(props);
  const { current, dragging } = useCarouselState(api);

  return {
    carouselRef: ref,
    carouselApi: api,
    current,
    dragging,
  };
}
